'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'sparkles';
var width = 512;
var height = 512;
var aliases = [10024];
var unicode = 'f890';
var svgPathData = ['M107.3 256l42.1 21.1 14.3 7.2 7.2 14.3L192 340.7l21.1-42.1 7.2-14.3 14.3-7.2L276.7 256l-42.1-21.1-14.3-7.2-7.2-14.3L192 171.3l-21.1 42.1-7.2 14.3-14.3 7.2L107.3 256z', 'M384 64L320 96l64 32 32 64 32-64 64-32L448 64 416 0 384 64zM256 320l74.3-37.2L384 256l-53.7-26.8L256 192l-37.2-74.3L192 64l-26.8 53.7L128 192 53.7 229.2 0 256l53.7 26.8L128 320l37.2 74.3L192 448l26.8-53.7L256 320zm-64 20.7l-21.1-42.1-7.2-14.3-14.3-7.2L107.3 256l42.1-21.1 14.3-7.2 7.2-14.3L192 171.3l21.1 42.1 7.2 14.3 14.3 7.2L276.7 256l-42.1 21.1-14.3 7.2-7.2 14.3L192 340.7zM416 320l-32 64-64 32 64 32 32 64 32-64 64-32-64-32-32-64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;